/* ============================================================
   Kiseau Cart — AJAX behaviour for the cart page + slide-out drawer.
   - Quantity / remove via /cart/change.js (Section Rendering re-render)
   - Quick-add via /cart/add.js (size chip carries the variant id)
   - Free-shipping meter + totals come straight from the re-rendered Liquid
   - "We think you'll like these" pulled from Search & Discovery related products
   - Keeps the theme header cart-count in sync (re-renders the cart-icon
     section + selector fallback) and dispatches cart events
   No dependencies. Safe to include from both sections (guarded below).
   ============================================================ */
(function () {
  if (window.__kCartInit) return;
  window.__kCartInit = true;

  var REC_SECTION = 'k-cart-recommendations';

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-kc-root]'));
  }
  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  // header cart-count integration (read from any root; set in the section settings)
  function headerCfg() {
    var r = document.querySelector('[data-kc-header-section]');
    return {
      section: (r && r.getAttribute('data-kc-header-section')) || 'cart-icon-bubble',
      target: (r && r.getAttribute('data-kc-header-target')) || '#cart-icon-bubble'
    };
  }

  function sectionIds() {
    var ids = roots()
      .map(function (r) { return r.getAttribute('data-section-id'); })
      .filter(Boolean);
    var h = headerCfg().section;
    if (h) ids.push(h);
    return ids.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  }

  var busy = false;

  /* ---------- cart mutations ---------- */
  function postCart(endpoint, body) {
    busy = true;
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return fetch(root() + 'cart/' + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { applyState(state); return state; })
      .catch(function (e) { if (window.console) console.warn('[k-cart]', e); })
      .then(function (state) { busy = false; return state; });
  }

  function changeLine(key, qty) {
    if (busy) return;
    return postCart('change.js', { id: key, quantity: qty });
  }

  function addVariant(variantId, btn) {
    if (busy || !variantId) return;
    if (btn) { btn.classList.add('kc-added'); btn.textContent = 'Added ✓'; }
    return postCart('add.js', { items: [{ id: variantId, quantity: 1 }] }).then(function (state) {
      openDrawer();
      if (btn) setTimeout(function () { btn.classList.remove('kc-added'); btn.textContent = 'Add'; }, 1600);
      return state;
    });
  }

  /* ---------- apply re-rendered sections ---------- */
  function applyState(state) {
    if (!state || !state.sections) return;

    roots().forEach(function (rootEl) {
      var id = rootEl.getAttribute('data-section-id');
      var html = state.sections[id];
      if (!html) return;
      var doc = parse(html);
      var newShell = doc.querySelector('[data-kc-shell]');
      var curShell = rootEl.querySelector('[data-kc-shell]');
      if (!newShell || !curShell) return;
      curShell.innerHTML = newShell.innerHTML;
      var rec = curShell.querySelector('[data-kc-rec]');
      if (rec && rootEl.__recCache) {
        var slot = rec.querySelector('[data-kc-rec-slot]');
        if (slot) { slot.innerHTML = rootEl.__recCache; rec.hidden = false; initRecCards(rec); }
      }
      loadRecs(rootEl);
    });

    // theme header cart count
    var cfg = headerCfg();
    if (cfg.section && state.sections[cfg.section]) {
      swapHeader(state.sections[cfg.section], cfg.target);
    } else if (typeof state.item_count === 'number') {
      countFallback(state.item_count);
    }

    // let the theme / apps know the cart changed
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {}
  }

  function swapHeader(html, target) {
    var doc = parse(html);
    var src = doc.querySelector(target) || doc.querySelector('.shopify-section') || doc.body;
    if (!src) return;
    Array.prototype.slice.call(document.querySelectorAll(target)).forEach(function (el) {
      el.innerHTML = src.innerHTML;
    });
  }

  function countFallback(n) {
    var sels = ['[data-cart-count]', '.cart-count', '.cart-count-bubble span', '.header__cart-count', '.site-header__cart-count', '.cart-link__bubble span'];
    document.querySelectorAll(sels.join(',')).forEach(function (el) {
      if (el.children.length === 0) el.textContent = n;
    });
  }

  /* ---------- recommendations ---------- */
  function loadRecs(rootEl) {
    var rec = rootEl.querySelector('[data-kc-rec]');
    if (!rec) return;
    var seed = rec.getAttribute('data-seed');
    var base = rec.getAttribute('data-rec-url');
    var limit = rec.getAttribute('data-rec-limit') || 6;
    if (!seed || !base) { rec.hidden = true; return; }
    var url = base + (base.indexOf('?') > -1 ? '&' : '?') +
      'section_id=' + REC_SECTION + '&product_id=' + seed + '&intent=related&limit=' + limit;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var cards = parse(html).querySelector('[data-kc-rec-cards]');
        var slot = rec.querySelector('[data-kc-rec-slot]');
        if (cards && slot && cards.innerHTML.trim()) {
          slot.innerHTML = cards.innerHTML;
          rootEl.__recCache = cards.innerHTML;
          rec.hidden = false;
          initRecCards(rec);
        } else {
          rec.hidden = true;
        }
      })
      .catch(function () { rec.hidden = true; });
  }

  function initRecCards(scope) {
    Array.prototype.slice.call(scope.querySelectorAll('[data-kc-rec-card]')).forEach(function (card) {
      var on = card.querySelector('[data-kc-sz].kc-on');
      var add = card.querySelector('[data-kc-rec-add]');
      if (on && add && on.getAttribute('data-variant-id')) {
        add.setAttribute('data-variant-id', on.getAttribute('data-variant-id'));
      }
    });
    var rec = (scope.matches && scope.matches('[data-kc-rec]')) ? scope : (scope.closest ? scope.closest('[data-kc-rec]') : null);
    if (rec) {
      var row = rec.querySelector('[data-kc-rec-slot]');
      if (row && !row.__kcScrollBound) {
        row.__kcScrollBound = true;
        row.addEventListener('scroll', function () { updateRecArrows(rec); }, { passive: true });
      }
      updateRecArrows(rec);
    }
  }

  // horizontal scroll for the upsell strip (arrow buttons for non-touch / laptop)
  function scrollRec(btn, dir) {
    var rec = btn.closest('[data-kc-rec]'); if (!rec) return;
    var row = rec.querySelector('[data-kc-rec-slot]'); if (!row) return;
    var amount = Math.max(row.clientWidth * 0.8, 180);
    row.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }
  function updateRecArrows(rec) {
    if (!rec) return;
    var row = rec.querySelector('[data-kc-rec-slot]');
    var prev = rec.querySelector('[data-kc-rec-prev]');
    var next = rec.querySelector('[data-kc-rec-next]');
    if (!row) return;
    var overflow = (row.scrollWidth - row.clientWidth) > 4;
    if (prev) { prev.style.display = overflow ? '' : 'none'; prev.disabled = row.scrollLeft <= 2; }
    if (next) { next.style.display = overflow ? '' : 'none'; next.disabled = row.scrollLeft >= (row.scrollWidth - row.clientWidth - 2); }
  }

  /* ---------- drawer ---------- */
  function drawerEls() {
    return {
      drawer: document.querySelector('[data-kc-drawer]'),
      overlay: document.querySelector('[data-kc-overlay]')
    };
  }
  function openDrawer() {
    var d = drawerEls();
    if (!d.drawer) return;
    d.drawer.classList.add('kc-open');
    if (d.overlay) d.overlay.classList.add('kc-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = drawerEls();
    if (!d.drawer) return;
    d.drawer.classList.remove('kc-open');
    if (d.overlay) d.overlay.classList.remove('kc-open');
    document.body.style.overflow = '';
  }
  // Bind the theme's cart icon(s) to open our drawer. Capture-phase + stop
  // propagation so we beat Eurus's own Alpine click handler / link navigation.
  // Keyed on #cart-icon-bubble (and the mobile dock variant), which we confirmed
  // exists in this theme — so it works whether the icon is a link or a button.
  function bindCartIcons() {
    if (!document.querySelector('[data-kc-drawer]')) return; // no drawer on page → leave the icon alone
    Array.prototype.slice.call(document.querySelectorAll('[id^="cart-icon-bubble"]')).forEach(function (bubble) {
      var trig = bubble.closest('a, button') || bubble.parentElement;
      if (!trig || trig.__kcBound) return;
      trig.__kcBound = true;
      trig.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openDrawer();
      }, true);
    });
  }
  window.KCart = { open: openDrawer, close: closeDrawer, bind: bindCartIcons, refresh: function () { roots().forEach(loadRecs); } };

  /* ---------- events (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // size chip
    var sz = t.closest('[data-kc-sz]');
    if (sz && !sz.hasAttribute('disabled')) {
      var sizes = sz.closest('[data-kc-sizes]');
      if (sizes) {
        Array.prototype.slice.call(sizes.querySelectorAll('[data-kc-sz]')).forEach(function (b) { b.classList.remove('kc-on'); });
        sz.classList.add('kc-on');
        var card = sz.closest('[data-kc-rec-card]');
        var add = card && card.querySelector('[data-kc-rec-add]');
        if (add && sz.getAttribute('data-variant-id')) add.setAttribute('data-variant-id', sz.getAttribute('data-variant-id'));
      }
      return;
    }

    // quick-add
    var addBtn = t.closest('[data-kc-rec-add]');
    if (addBtn && !addBtn.hasAttribute('disabled')) {
      e.preventDefault();
      addVariant(addBtn.getAttribute('data-variant-id'), addBtn);
      return;
    }

    // quantity + remove
    var item = t.closest('[data-kc-item]');
    if (item) {
      var key = item.getAttribute('data-key');
      var qEl = item.querySelector('[data-kc-qty]');
      var q = qEl ? parseInt(qEl.textContent, 10) : 1;
      if (t.closest('[data-kc-plus]')) { item.classList.add('kc-busy'); changeLine(key, q + 1); return; }
      if (t.closest('[data-kc-minus]')) { item.classList.add('kc-busy'); changeLine(key, q - 1); return; }
      if (t.closest('[data-kc-remove]')) { item.classList.add('kc-busy'); changeLine(key, 0); return; }
    }

    // recommendations arrows
    var recPrev = t.closest('[data-kc-rec-prev]');
    if (recPrev) { scrollRec(recPrev, -1); return; }
    var recNext = t.closest('[data-kc-rec-next]');
    if (recNext) { scrollRec(recNext, 1); return; }

    // recommendations collapse
    var recToggle = t.closest('[data-kc-rec-toggle]');
    if (recToggle) { var rec = recToggle.closest('[data-kc-rec]'); if (rec) rec.classList.toggle('kc-collapsed'); return; }

    // checkout (JS shortcut; the <form> submit is the no-JS fallback)
    if (t.closest('[data-kc-checkout]')) { e.preventDefault(); window.location.href = root() + 'checkout'; return; }

    // open / close drawer
    if (t.closest('[data-kc-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-kc-close]') || t.closest('[data-kc-overlay]')) { e.preventDefault(); closeDrawer(); return; }

    // intercept links to /cart -> open drawer
    var drawer = document.querySelector('[data-kc-drawer]');
    if (drawer && drawer.getAttribute('data-kc-intercept') === 'true') {
      var link = t.closest('a[href]');
      if (link) {
        var path = (link.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
        if (path === (root() + 'cart').replace(/\/$/, '') || /\/cart$/.test(path)) {
          e.preventDefault();
          openDrawer();
        }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Intercept the theme's add-to-cart forms → AJAX add + open our drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!document.querySelector('[data-kc-drawer]')) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    var fd = new FormData(form);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        busy = false;
        if (state && state.status) return; // add error (sold out, etc.) — leave it to the theme
        applyState(state);
        openDrawer();
      })
      .catch(function (err) { busy = false; if (window.console) console.warn('[k-cart]', err); });
  }, true);

  // Eurus (Cart type = Page) AJAX-adds the item, then fires "eurus:cart:redirect"
  // to send the shopper to /cart. Intercept it (capture phase, before Eurus's own
  // listener) and open OUR drawer instead — the item is already in the cart.
  document.addEventListener('eurus:cart:redirect', function (e) {
    if (!document.querySelector('[data-kc-drawer]')) return;
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    refreshAndOpen();
  }, true);

  // Re-render the cart sections from the current server cart, then open the drawer.
  // Uses POST /cart/update.js (never cached) rather than a GET ?sections= request,
  // which Shopify's CDN can serve stale/empty right after an add.
  function refreshAndOpen() {
    var ids = sectionIds();
    if (!ids.length) { openDrawer(); return; }
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ sections: ids.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { applyState(state); openDrawer(); })
      .catch(function () { openDrawer(); });
  }

  /* ---------- init ---------- */
  function init() {
    bindCartIcons();
    roots().forEach(function (rootEl) { loadRecs(rootEl); });
    window.addEventListener('resize', function () {
      Array.prototype.slice.call(document.querySelectorAll('[data-kc-rec]')).forEach(updateRecArrows);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
